export default {"src":"/_next/static/media/mobile_de.e3f246db.svg","height":25,"width":102,"blurWidth":0,"blurHeight":0};